export default __webpack_public_path__ + "static/media/card_premio_reclame_aqui.a45bad2b.webp";